










































import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component
export default class CustomDialog extends Vue {
  @Prop({ default: '' }) public headerTitle!: string;
  @Prop({ default: '520' }) public maxWidth!: string | number;
  @Prop({default: '500px' }) public contentHeight!: string | number;
  @Prop({ default: 'true' }) public header!: boolean;
  @Prop({ default: false }) public persistent!: boolean;
  @Model('change', { type: Boolean }) public showDialog!: boolean;

  // decided if close button will show up, default: true
  @Prop({ default: true }) public closeButton!: boolean;

  @Watch('showDialog')
  public onShowChange(val: boolean) {
    this.$emit('change', val);
  }

  public close() {
    // emit to parent component to change the model
    this.$emit('change', false);
  }

  public onDialogClose() {
    // this will be called if dialog clossed by clicking outside of dialog
    this.close();
  }
}
